import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { useCallContext } from '@gem/call/CallView/CallView.context';

interface IGroupVideoCallHeaderPresenter {
  call: Call;
}

export const useGroupVideoCallHeaderPresenter = (): IGroupVideoCallHeaderPresenter => {
  const context = useCallContext();

  return useLocalObservable<IGroupVideoCallHeaderPresenter>(() => ({
    get call(): Call {
      return context.call;
    },
  }));
};
